export default __webpack_public_path__ + "static/media/red-envelope.aa7ee635.svg";